<template>
  <div class="wrap">
    <!-- <van-nav-bar title="网上办事" /> -->

    <!-- 列表 -->
    <div class="special">
      <van-cell
        :key="index"
        is-link
        v-for="(item, index) in NWKindList"
        @click="goWork(item)"
      >
        <!-- :to="'/work/' + item.NWKId" -->
        <img :src="item.appletIcon" class="linkicon" />{{
          item.Name
        }}</van-cell
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
import wx from "weixin-js-sdk";
import { WeGetNWKindList } from "@/api/Network";
import {WeIsMember} from '@/api/PartyInfo'
import { setOpenId, getOpenId } from "@/utils/auth";
import {WxIsMember} from "@/api/yeguang";
export default {
  components: {},
  data() {
    return {
      NWKindList: [],
    };
  },
  created() {
    this.getNWKindList();
    this.weIsMember();
  },
  methods: {
    goWork(scop) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../home/homeList/index?NWKId=" + scop.NWKId,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    // 获取办事类型列表
    getNWKindList() {
      WeGetNWKindList().then((res) => {
        this.NWKindList = res.data.data;
      });
    },
    // 获取会员类型
    weIsMember(){
      // getOpenId()
      // WeIsMember({OpenID:getOpenId()}).then((res)=>{
      //   if(res.data.data == 1){ //已注册
      //     return false;
      //   }else if(res.data.data == 0){ //未注册
      //     Toast.fail('未注册会员!需注册后方可提交网上办事!');
      //   }else if(res.data.data == 2){ //注册但未审核
      //     Toast.fail('注册尚未通过!请联系社区进行审核!');
      //   }
      // })

      WxIsMember({ OpenID: getOpenId(),reqToken:'' }).then((res) => {
        if (res.data.code == 0) {
          // if(res.data.data.status==1){
          //   this.verifyshow =1;
          //   if (this.verifyshow == 1) {
          //     this.getMemberXq(res.data.data.Mobile);
          //   }
          // }
            if(res.data.data.status == 1){ //已注册
              return false;
            }else if(res.data.data.status == 2){ //注册但未审核
              Toast.fail('注册尚未通过!请联系社区进行审核!');
            }else{ //未注册
              Toast.fail('未注册会员!需注册后方可提交网上办事!');
            }
        }
      });
    },
  },
};
</script>

<style>
.special {
  padding: 10px 10px;
}
.special img {
  position: relative;
  top: 30%;
  margin-top: -10px;
  width: 24px;
  height: 24px;
}
</style>
